var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang === "nl"
    ? _c("div", {
        staticStyle: {
          height: "100vh",
          margin: "-5px 0",
          "background-color": "#FF0000"
        },
        attrs: {
          id: "wrapper",
          "data-tf-widget": _vm.urlNl,
          "data-tf-inline-on-mobile": "",
          "data-tf-medium": "snippet"
        }
      })
    : _vm.lang === "fr"
    ? _c("div", {
        staticStyle: {
          height: "100vh",
          margin: "-5px 0",
          "background-color": "#FF0000"
        },
        attrs: {
          id: "wrapper",
          "data-tf-widget": _vm.urlFr,
          "data-tf-inline-on-mobile": "",
          "data-tf-medium": "snippet"
        }
      })
    : _vm.lang === "en"
    ? _c("div", {
        staticStyle: {
          height: "100vh",
          margin: "-5px 0",
          "background-color": "#FF0000"
        },
        attrs: {
          id: "wrapper",
          "data-tf-widget": _vm.urlEn,
          "data-tf-inline-on-mobile": "",
          "data-tf-medium": "snippet"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }